import { CommonModule } from '@angular/common';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { ToastService } from './toast.service';
import { Toast, ToastType } from './toast';
import { Subscription } from 'rxjs';

interface ToastWithId extends Toast {
  id: number;
}

@Component({
  selector: 'app-toast',
  imports: [CommonModule],
  templateUrl: './toast.component.html',
  styleUrl: './toast.component.scss'
})
export class ToastComponent implements OnInit, OnDestroy {

  toasts: ToastWithId[] = [];
  private subscription: Subscription = new Subscription();

  constructor(private toastService: ToastService) {}

  ngOnInit(): void {
    this.subscription = this.toastService.getNewToast().subscribe((toast: Toast) => {
      this.addToast(toast);
    });
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  private addToast(toast: Toast): void {
    // Adiciona um ID único para cada toast
    const toastWithId: ToastWithId = { ...toast, id: Date.now() + Math.random() };
    this.toasts.push(toastWithId);

    // Remove o toast após a animação de fadeOut (5s + 1s = 6s total)
    setTimeout(() => {
      this.removeToast(toastWithId.id);
    }, 6000);
  }

  private removeToast(toastId: number): void {
    this.toasts = this.toasts.filter(toast => toast.id !== toastId);
  }

  // Método público para remover toast manualmente
  public closeToast(toastId: number): void {
    this.removeToast(toastId);
  }

  // Getter para verificar se há toasts para exibir
  get hasToasts(): boolean {
    return this.toasts.length > 0;
  }
}
